import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  JSON: { input: any; output: any };
  Time: { input: any; output: any };
};

export type Coupon = {
  code: Scalars['String']['output'];
  expirationDate: Scalars['Time']['output'];
  finalPrice: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Float']['output'];
  programId?: Maybe<Scalars['String']['output']>;
  status: CouponStatus;
  subscriptionPlanId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: CouponType;
};

export type CouponResult = {
  data?: Maybe<Coupon>;
  status: Status;
};

export enum CouponStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Used = 'USED',
}

export enum CouponType {
  OnlineScreening = 'ONLINE_SCREENING',
  Subscription = 'SUBSCRIPTION',
}

export type GetPaymentMethodsResult = {
  data?: Maybe<Array<PaymentMethod>>;
  status: Status;
};

export type Language = {
  code: LanguageCode;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum LanguageCode {
  En = 'EN',
  Fa = 'FA',
}

export type MarketPaymentInput = {
  meta?: InputMaybe<Scalars['JSON']['input']>;
  paymentMethodID: Scalars['String']['input'];
  planID: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type Mutation = {
  createScreeningPayment: UserPaymentResult;
  createSubscriptionPayment: UserPaymentResult;
  requestNewMobile: Status;
  requestUpdateMobile: Status;
  updateProfile: Status;
  validateMarketPayment: UserSubscriptionPlanResult;
  validateNewMobile: Status;
  validateUpdateMobile: ResultWithSecret;
};

export type MutationCreateScreeningPaymentArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  paymentMethodID: Scalars['String']['input'];
  screeningID: Scalars['String']['input'];
};

export type MutationCreateSubscriptionPaymentArgs = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  paymentMethodID: Scalars['String']['input'];
  subscriptionPlanID: Scalars['String']['input'];
};

export type MutationRequestNewMobileArgs = {
  by: UpdateMobileBy;
  newMobile: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type MutationRequestUpdateMobileArgs = {
  by: UpdateMobileBy;
};

export type MutationUpdateProfileArgs = {
  fullName: Scalars['String']['input'];
  gender: UserGender;
};

export type MutationValidateMarketPaymentArgs = {
  payload: MarketPaymentInput;
};

export type MutationValidateNewMobileArgs = {
  by: UpdateMobileBy;
  token2: Scalars['String']['input'];
};

export type MutationValidateUpdateMobileArgs = {
  by: UpdateMobileBy;
  token: Scalars['String']['input'];
};

export type OnlineScreening = {
  endDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  programId: Scalars['String']['output'];
  startDate: Scalars['Time']['output'];
  status: OnlineScreeningStatus;
  tax: Scalars['Int']['output'];
  ticketPrice: Scalars['Int']['output'];
  validFor: Scalars['Int']['output'];
};

export type OnlineScreeningPagable = {
  currentPage: Scalars['Int']['output'];
  data?: Maybe<Array<OnlineScreening>>;
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export enum OnlineScreeningStatus {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED',
}

export type PaymentMethod = {
  id: Scalars['ID']['output'];
  logoPath: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentType: PaymentType;
};

export enum PaymentType {
  AutoCharge = 'AUTO_CHARGE',
  Online = 'ONLINE',
  Wallet = 'WALLET',
}

export type Query = {
  getCouponDetails: CouponResult;
  getLastUserSubscriptionPlan: UserSubscriptionPlanResult;
  getPaymentMethods: GetPaymentMethodsResult;
  getSubscriptionPlans: SubscriptionPlansResult;
  getUserPayment: UserPaymentResult;
  getUserPayments: UserPaymentsResult;
  getUserScreening: UserOnlineScreeningResult;
  getUserScreenings: UserOnlineScreeningsResult;
  getUserSubscriptionDetails: UserSubscriptionDetailsResult;
  getUserSubscriptionPlans: UserSubscriptionPlansResult;
  validateScreeningCoupon: CouponResult;
  validateSubscriptionCoupon: CouponResult;
};

export type QueryGetCouponDetailsArgs = {
  couponCode: Scalars['String']['input'];
};

export type QueryGetUserPaymentArgs = {
  invoiceNumber: Scalars['String']['input'];
};

export type QueryGetUserPaymentsArgs = {
  page: Scalars['Int']['input'];
  usageType: UserPaymentUsageType;
};

export type QueryGetUserScreeningArgs = {
  programID: Scalars['String']['input'];
};

export type QueryGetUserScreeningsArgs = {
  page: Scalars['Int']['input'];
};

export type QueryGetUserSubscriptionPlansArgs = {
  page: Scalars['Int']['input'];
};

export type QueryValidateScreeningCouponArgs = {
  couponCode: Scalars['String']['input'];
  screeningID: Scalars['String']['input'];
};

export type QueryValidateSubscriptionCouponArgs = {
  couponCode: Scalars['String']['input'];
  subscriptionPlanID: Scalars['String']['input'];
};

export type ResultWithSecret = {
  error?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type Status = {
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export type SubscriptionPlan = {
  description: Scalars['String']['output'];
  discountPercentage: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  finalPrice?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  logoPath?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  taxPercentage: Scalars['Int']['output'];
};

export type SubscriptionPlanInput = {
  description: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export enum SubscriptionPlanStatus {
  Activated = 'ACTIVATED',
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
}

export type SubscriptionPlansResult = {
  data?: Maybe<Array<SubscriptionPlan>>;
  status: Status;
};

export enum UpdateMobileBy {
  Email = 'EMAIL',
  Mobile = 'MOBILE',
}

export enum UpdatePasswordBy {
  Email = 'EMAIL',
  Mobile = 'MOBILE',
  Password = 'PASSWORD',
}

export type User = {
  createdAt: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mobile: Scalars['String']['output'];
  password: Scalars['String']['output'];
  status: UserStatus;
  updatedAt: Scalars['Time']['output'];
};

export enum UserGender {
  Female = 'FEMALE',
  Male = 'MALE',
  Un = 'UN',
}

export type UserInput = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UserOnlineScreening = {
  endingDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  programID: Scalars['String']['output'];
  screeningID: Scalars['String']['output'];
  startingDate: Scalars['Time']['output'];
  status: UserOnlineScreeningStatus;
};

export type UserOnlineScreeningPagable = {
  currentPage: Scalars['Int']['output'];
  data?: Maybe<Array<UserOnlineScreening>>;
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type UserOnlineScreeningResult = {
  data?: Maybe<UserOnlineScreening>;
  status: Status;
};

export enum UserOnlineScreeningStatus {
  Activated = 'ACTIVATED',
  Expired = 'EXPIRED',
}

export type UserOnlineScreeningsResult = {
  data: UserOnlineScreeningPagable;
  status: Status;
};

export type UserPayment = {
  coupon?: Maybe<Coupon>;
  gatewayTrackingNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  paymentMethod: PaymentMethod;
  paymentMethodId: Scalars['String']['output'];
  productCode: Scalars['Int']['output'];
  screening?: Maybe<OnlineScreening>;
  screeningId?: Maybe<Scalars['String']['output']>;
  status: UserPaymentStatus;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  subscriptionPlanId?: Maybe<Scalars['String']['output']>;
  taxPercentage: Scalars['Int']['output'];
  totalPrice: Scalars['Int']['output'];
  trackingNumber: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  usageType: UserPaymentUsageType;
  userId: Scalars['String']['output'];
  userScreening?: Maybe<UserOnlineScreening>;
  userScreeningId?: Maybe<Scalars['String']['output']>;
  userSubscriptionPlan?: Maybe<UserSubscriptionPlan>;
  userSubscriptionPlanId?: Maybe<Scalars['String']['output']>;
};

export type UserPaymentPagable = {
  currentPage: Scalars['Int']['output'];
  data?: Maybe<Array<UserPayment>>;
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type UserPaymentResult = {
  data?: Maybe<UserPayment>;
  status: Status;
};

export enum UserPaymentStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  Paid = 'PAID',
}

export enum UserPaymentUsageType {
  OnlineScreening = 'ONLINE_SCREENING',
  Subscription = 'SUBSCRIPTION',
}

export type UserPaymentsResult = {
  data: UserPaymentPagable;
  status: Status;
};

export enum UserStatus {
  Activated = 'ACTIVATED',
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Suspended = 'SUSPENDED',
}

export type UserSubscriptionDetails = {
  latestSubscription?: Maybe<UserSubscriptionPlan>;
  remainingDays: Scalars['Int']['output'];
  subscriptionISP?: Maybe<Scalars['String']['output']>;
  subscriptionType: UserSubscriptionType;
};

export type UserSubscriptionDetailsResult = {
  data?: Maybe<UserSubscriptionDetails>;
  status: Status;
};

export type UserSubscriptionPlan = {
  createdAt: Scalars['Time']['output'];
  endsIn: Scalars['Time']['output'];
  extendedTime: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  startsIn: Scalars['Time']['output'];
  status: UserSubscriptionPlanStatus;
  subscriptionPlan: SubscriptionPlan;
  subscriptionPlanId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  userId: Scalars['String']['output'];
  userPayment: UserPayment;
};

export type UserSubscriptionPlanPagable = {
  currentPage: Scalars['Int']['output'];
  data?: Maybe<Array<UserSubscriptionPlan>>;
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type UserSubscriptionPlanResult = {
  data?: Maybe<UserSubscriptionPlan>;
  status: Status;
};

export enum UserSubscriptionPlanStatus {
  Activated = 'ACTIVATED',
  Expired = 'EXPIRED',
  Waiting = 'WAITING',
}

export type UserSubscriptionPlansResult = {
  data: UserSubscriptionPlanPagable;
  status: Status;
};

export enum UserSubscriptionType {
  IspSubscription = 'ISP_SUBSCRIPTION',
  NoSubscription = 'NO_SUBSCRIPTION',
  Subscribed = 'SUBSCRIBED',
}

export type GetUserScreeningQueryVariables = Exact<{
  programID: Scalars['String']['input'];
}>;

export type GetUserScreeningQuery = {
  getUserScreening: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      screeningID: string;
      programID: string;
      startingDate: any;
      endingDate: any;
      status: UserOnlineScreeningStatus;
    } | null;
  };
};

export type GetUserScreeningsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetUserScreeningsQuery = {
  getUserScreenings: {
    status: { message: string; statusCode: number };
    data: {
      totalRecords: number;
      totalPages: number;
      currentPage: number;
      data?: Array<{
        id: string;
        screeningID: string;
        programID: string;
        startingDate: any;
        endingDate: any;
        status: UserOnlineScreeningStatus;
      }> | null;
    };
  };
};

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPaymentMethodsQuery = {
  getPaymentMethods: {
    status: { message: string; statusCode: number };
    data?: Array<{ id: string; name: string; logoPath: string }> | null;
  };
};

export type CreateSubscriptionPaymentMutationVariables = Exact<{
  planID: Scalars['String']['input'];
  methodID: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateSubscriptionPaymentMutation = {
  createSubscriptionPayment: {
    status: { message: string; statusCode: number };
    data?: { url: string } | null;
  };
};

export type CreateScreeningPaymentMutationVariables = Exact<{
  screeningID: Scalars['String']['input'];
  methodID: Scalars['String']['input'];
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateScreeningPaymentMutation = {
  createScreeningPayment: {
    status: { message: string; statusCode: number };
    data?: { url: string } | null;
  };
};

export type GetUserPaymentQueryVariables = Exact<{
  invoiceNumber: Scalars['String']['input'];
}>;

export type GetUserPaymentQuery = {
  getUserPayment: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      status: UserPaymentStatus;
      totalPrice: number;
      trackingNumber: string;
      updatedAt: number;
      screening?: {
        endDate: any;
        id: string;
        programId: string;
        startDate: any;
        status: OnlineScreeningStatus;
        tax: number;
        ticketPrice: number;
        validFor: number;
      } | null;
      paymentMethod: { id: string; name: string; logoPath: string; paymentType: PaymentType };
      subscriptionPlan?: {
        id: string;
        name: string;
        description: string;
        duration: number;
        discountPercentage: number;
        finalPrice?: number | null;
        price: number;
        logoPath?: string | null;
      } | null;
      coupon?: {
        id: string;
        title: string;
        code: string;
        percentage: number;
        expirationDate: any;
      } | null;
    } | null;
  };
};

export type GetUserPaymentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  usageType: UserPaymentUsageType;
}>;

export type GetUserPaymentsQuery = {
  getUserPayments: {
    status: { message: string; statusCode: number };
    data: {
      totalRecords: number;
      totalPages: number;
      currentPage: number;
      data?: Array<{
        id: string;
        userId: string;
        status: UserPaymentStatus;
        usageType: UserPaymentUsageType;
        totalPrice: number;
        taxPercentage: number;
        trackingNumber: string;
        gatewayTrackingNumber: string;
        productCode: number;
        url: string;
        updatedAt: number;
        paymentMethod: { id: string; name: string; logoPath: string; paymentType: PaymentType };
        subscriptionPlan?: {
          id: string;
          name: string;
          description: string;
          duration: number;
          price: number;
          discountPercentage: number;
          finalPrice?: number | null;
          taxPercentage: number;
          logoPath?: string | null;
        } | null;
        userSubscriptionPlan?: {
          id: string;
          userId: string;
          subscriptionPlanId: string;
          status: UserSubscriptionPlanStatus;
          startsIn: any;
          endsIn: any;
          price: number;
          updatedAt?: any | null;
          createdAt: any;
          extendedTime: number;
        } | null;
        userScreening?: {
          id: string;
          screeningID: string;
          programID: string;
          startingDate: any;
          endingDate: any;
          status: UserOnlineScreeningStatus;
        } | null;
        coupon?: {
          id: string;
          title: string;
          code: string;
          programId?: string | null;
          subscriptionPlanId?: string | null;
          percentage: number;
          finalPrice: number;
          expirationDate: any;
          status: CouponStatus;
          type: CouponType;
        } | null;
      }> | null;
    };
  };
};

export type GetUserSubscriptionDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserSubscriptionDetailsQuery = {
  getUserSubscriptionDetails: {
    status: { message: string; statusCode: number };
    data?: {
      remainingDays: number;
      latestSubscription?: {
        id: string;
        userId: string;
        subscriptionPlanId: string;
        status: UserSubscriptionPlanStatus;
        startsIn: any;
        endsIn: any;
        price: number;
        updatedAt?: any | null;
        createdAt: any;
        extendedTime: number;
      } | null;
    } | null;
  };
};

export type RequestUpdateMobileMutationVariables = Exact<{ [key: string]: never }>;

export type RequestUpdateMobileMutation = {
  requestUpdateMobile: { message: string; statusCode: number };
};

export type ValidateUpdateMobileMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type ValidateUpdateMobileMutation = {
  validateUpdateMobile: { secret?: string | null; status: { message: string; statusCode: number } };
};

export type RequestNewMobileMutationVariables = Exact<{
  newMobile: Scalars['String']['input'];
  secret: Scalars['String']['input'];
}>;

export type RequestNewMobileMutation = {
  requestNewMobile: { message: string; statusCode: number };
};

export type ValidateNewMobileMutationVariables = Exact<{
  token2: Scalars['String']['input'];
}>;

export type ValidateNewMobileMutation = {
  validateNewMobile: { message: string; statusCode: number };
};

export type StatusFragmentFieldsFragment = { message: string; statusCode: number };

export type GetSubscriptionPlansQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubscriptionPlansQuery = {
  getSubscriptionPlans: {
    status: { message: string; statusCode: number };
    data?: Array<{
      id: string;
      name: string;
      description: string;
      duration: number;
      discountPercentage: number;
      finalPrice?: number | null;
    }> | null;
  };
};

export type ValidateScreeningCouponQueryVariables = Exact<{
  screeningID: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;

export type ValidateScreeningCouponQuery = {
  validateScreeningCoupon: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      title: string;
      code: string;
      programId?: string | null;
      percentage: number;
      finalPrice: number;
      expirationDate: any;
      status: CouponStatus;
      type: CouponType;
    } | null;
  };
};

export type GetCouponDetailsQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type GetCouponDetailsQuery = {
  getCouponDetails: {
    status: { message: string; statusCode: number };
    data?: {
      id: string;
      title: string;
      code: string;
      programId?: string | null;
      subscriptionPlanId?: string | null;
      percentage: number;
      finalPrice: number;
      expirationDate: any;
      status: CouponStatus;
      type: CouponType;
    } | null;
  };
};

export const StatusFragmentFieldsFragmentDoc = gql`
  fragment StatusFragmentFields on Status {
    message
    statusCode
  }
`;
export const GetUserScreeningDocument = gql`
  query getUserScreening($programID: String!) {
    getUserScreening(programID: $programID) {
      status {
        ...StatusFragmentFields
      }
      data {
        id
        screeningID
        programID
        startingDate
        endingDate
        status
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserScreeningQueryService extends Apollo.Query<
  GetUserScreeningQuery,
  GetUserScreeningQueryVariables
> {
  override document = GetUserScreeningDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserScreeningsDocument = gql`
  query getUserScreenings($page: Int = 1) {
    getUserScreenings(page: $page) {
      status {
        ...StatusFragmentFields
      }
      data {
        totalRecords
        totalPages
        currentPage
        data {
          id
          screeningID
          programID
          startingDate
          endingDate
          status
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserScreeningsQueryService extends Apollo.Query<
  GetUserScreeningsQuery,
  GetUserScreeningsQueryVariables
> {
  override document = GetUserScreeningsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPaymentMethodsDocument = gql`
  query getPaymentMethods {
    getPaymentMethods {
      status {
        ...StatusFragmentFields
      }
      data {
        id
        name
        logoPath
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetPaymentMethodsQueryService extends Apollo.Query<
  GetPaymentMethodsQuery,
  GetPaymentMethodsQueryVariables
> {
  override document = GetPaymentMethodsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateSubscriptionPaymentDocument = gql`
  mutation createSubscriptionPayment($planID: String!, $methodID: String!, $couponCode: String) {
    createSubscriptionPayment(
      subscriptionPlanID: $planID
      paymentMethodID: $methodID
      couponCode: $couponCode
    ) {
      status {
        ...StatusFragmentFields
      }
      data {
        url
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateSubscriptionPaymentMutationService extends Apollo.Mutation<
  CreateSubscriptionPaymentMutation,
  CreateSubscriptionPaymentMutationVariables
> {
  override document = CreateSubscriptionPaymentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateScreeningPaymentDocument = gql`
  mutation createScreeningPayment($screeningID: String!, $methodID: String!, $couponCode: String) {
    createScreeningPayment(
      screeningID: $screeningID
      paymentMethodID: $methodID
      couponCode: $couponCode
    ) {
      status {
        ...StatusFragmentFields
      }
      data {
        url
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateScreeningPaymentMutationService extends Apollo.Mutation<
  CreateScreeningPaymentMutation,
  CreateScreeningPaymentMutationVariables
> {
  override document = CreateScreeningPaymentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserPaymentDocument = gql`
  query getUserPayment($invoiceNumber: String!) {
    getUserPayment(invoiceNumber: $invoiceNumber) {
      status {
        ...StatusFragmentFields
      }
      data {
        id
        status
        totalPrice
        trackingNumber
        updatedAt
        screening {
          endDate
          id
          programId
          startDate
          status
          tax
          ticketPrice
          validFor
        }
        paymentMethod {
          id
          name
          logoPath
          paymentType
        }
        subscriptionPlan {
          id
          name
          description
          duration
          discountPercentage
          finalPrice
          price
          logoPath
        }
        coupon {
          id
          title
          code
          percentage
          expirationDate
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserPaymentQueryService extends Apollo.Query<
  GetUserPaymentQuery,
  GetUserPaymentQueryVariables
> {
  override document = GetUserPaymentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserPaymentsDocument = gql`
  query getUserPayments($page: Int = 1, $usageType: UserPaymentUsageType!) {
    getUserPayments(page: $page, usageType: $usageType) {
      status {
        ...StatusFragmentFields
      }
      data {
        totalRecords
        totalPages
        currentPage
        data {
          id
          userId
          status
          usageType
          totalPrice
          taxPercentage
          trackingNumber
          gatewayTrackingNumber
          productCode
          url
          updatedAt
          paymentMethod {
            id
            name
            logoPath
            paymentType
          }
          subscriptionPlan {
            id
            name
            description
            duration
            price
            discountPercentage
            finalPrice
            taxPercentage
            logoPath
          }
          userSubscriptionPlan {
            id
            userId
            subscriptionPlanId
            status
            startsIn
            endsIn
            price
            updatedAt
            createdAt
            extendedTime
          }
          userScreening {
            id
            screeningID
            programID
            startingDate
            endingDate
            status
          }
          coupon {
            id
            title
            code
            programId
            subscriptionPlanId
            percentage
            finalPrice
            expirationDate
            status
            type
          }
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserPaymentsQueryService extends Apollo.Query<
  GetUserPaymentsQuery,
  GetUserPaymentsQueryVariables
> {
  override document = GetUserPaymentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserSubscriptionDetailsDocument = gql`
  query getUserSubscriptionDetails {
    getUserSubscriptionDetails {
      status {
        ...StatusFragmentFields
      }
      data {
        remainingDays
        latestSubscription {
          id
          userId
          subscriptionPlanId
          status
          startsIn
          endsIn
          price
          updatedAt
          createdAt
          extendedTime
        }
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserSubscriptionDetailsQueryService extends Apollo.Query<
  GetUserSubscriptionDetailsQuery,
  GetUserSubscriptionDetailsQueryVariables
> {
  override document = GetUserSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestUpdateMobileDocument = gql`
  mutation requestUpdateMobile {
    requestUpdateMobile(by: MOBILE) {
      message
      statusCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestUpdateMobileMutationService extends Apollo.Mutation<
  RequestUpdateMobileMutation,
  RequestUpdateMobileMutationVariables
> {
  override document = RequestUpdateMobileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ValidateUpdateMobileDocument = gql`
  mutation validateUpdateMobile($token: String!) {
    validateUpdateMobile(by: MOBILE, token: $token) {
      status {
        ...StatusFragmentFields
      }
      secret
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ValidateUpdateMobileMutationService extends Apollo.Mutation<
  ValidateUpdateMobileMutation,
  ValidateUpdateMobileMutationVariables
> {
  override document = ValidateUpdateMobileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestNewMobileDocument = gql`
  mutation requestNewMobile($newMobile: String!, $secret: String!) {
    requestNewMobile(by: MOBILE, newMobile: $newMobile, secret: $secret) {
      message
      statusCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestNewMobileMutationService extends Apollo.Mutation<
  RequestNewMobileMutation,
  RequestNewMobileMutationVariables
> {
  override document = RequestNewMobileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ValidateNewMobileDocument = gql`
  mutation validateNewMobile($token2: String!) {
    validateNewMobile(by: MOBILE, token2: $token2) {
      message
      statusCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ValidateNewMobileMutationService extends Apollo.Mutation<
  ValidateNewMobileMutation,
  ValidateNewMobileMutationVariables
> {
  override document = ValidateNewMobileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSubscriptionPlansDocument = gql`
  query getSubscriptionPlans {
    getSubscriptionPlans {
      status {
        ...StatusFragmentFields
      }
      data {
        id
        name
        description
        duration
        discountPercentage
        finalPrice
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSubscriptionPlansQueryService extends Apollo.Query<
  GetSubscriptionPlansQuery,
  GetSubscriptionPlansQueryVariables
> {
  override document = GetSubscriptionPlansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ValidateScreeningCouponDocument = gql`
  query validateScreeningCoupon($screeningID: String!, $code: String!) {
    validateScreeningCoupon(screeningID: $screeningID, couponCode: $code) {
      status {
        ...StatusFragmentFields
      }
      data {
        id
        title
        code
        programId
        percentage
        finalPrice
        expirationDate
        status
        type
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ValidateScreeningCouponQueryService extends Apollo.Query<
  ValidateScreeningCouponQuery,
  ValidateScreeningCouponQueryVariables
> {
  override document = ValidateScreeningCouponDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCouponDetailsDocument = gql`
  query getCouponDetails($code: String!) {
    getCouponDetails(couponCode: $code) {
      status {
        ...StatusFragmentFields
      }
      data {
        id
        title
        code
        programId
        subscriptionPlanId
        percentage
        finalPrice
        expirationDate
        status
        type
      }
    }
  }
  ${StatusFragmentFieldsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetCouponDetailsQueryService extends Apollo.Query<
  GetCouponDetailsQuery,
  GetCouponDetailsQueryVariables
> {
  override document = GetCouponDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
